export default __webpack_public_path__ + "static/media/J750_CoC.8c7882b7.pdf";